import Card from 'components/card';
import StudentFeeDetails from './Steps/StepTwo';

const Index = () => {
  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <Card extra=" -mt-[280px] w-full md:-mt-[240px] md:px-[70px] h-full mx-auto pb-3">
          <div className="rounded-[20px]">
            <StudentFeeDetails />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Index;
